import { type ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useMe } from './MeContext';
import type { OperatorFlag } from '../lib/api/operatorConsole';

/**
 * Route guard for a page an operator-level feature flag turns on. Pages whose
 * data the backend hides behind the flag answer its 404 themselves (My Packs,
 * Metrics); this is for a screen that reads what an open page reads too —
 * Pack Opening loads the template theme exactly like Themes — so the flag on
 * /me is the only thing that says whether the screen exists.
 *
 * Cosmetic only, like RequireSection: the backend ignores the animation
 * section on write while the flag is off, reached or not.
 */
export function RequireFlag({ flag, children }: { flag: OperatorFlag; children: ReactNode }) {
  const { has } = useMe();

  // Dashboard is open to everyone, so it is always a safe place to land.
  if (!has(flag)) return <Navigate to="/" replace />;

  return <>{children}</>;
}
